/**
 * * Запрос на перемещение задачи в очереди
            Описание: нужно указать айди задач между которыми встанет перемещаемая задача(верхняя и нижняя)
            1)Если задача перемещается в самый вверх то нужно передать только нижнюю задачу
            1)Если задача перемещается в самый низ то нужно передать только верхнюю
 */
export class TaskMoveQueueRequestModel {
  /**
   * * Айди верхней задачи
   */
  TaskUpId?: number;
  /**
   * * Айди нижней задачи задачи
   */
  TaskDownId?: number;
  /**
   * * Айди перемещаемой задачи
   */
  TaskMoveId!: number;
  constructor(obj?: Partial<TaskMoveQueueRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
